export default "__VITE_ASSET__ZgsLmm9___"